import { moduleStyleType } from 'components/no-ui/styles/styleTypes'

export const TaskActionButton: moduleStyleType = {
    item: {
        marginRight: 1,
    },
    insightsIcon: {
        color: 'currentColor',
    },
    whiteIcon: {
        color: 'primary.contrastText',
    },
    insightsReviewIcon: {
        color: 'currentColor',
    },
}
